import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

import { configHbA1c, dataConfigHbA1c } from "./graph-hba1c";
import { configImc, dataConfigImc } from "./graph-imc";
import { configInsuline, dataConfigInsuline } from "./graph-insuline";
import { configTir, dataConfigTir } from "./graph-tir";

const graphMetrics = [
  {
    dataConfig: dataConfigHbA1c,
    options: configHbA1c,
    plugins: ChartDataLabels,
    element: Bar,
  },
  {
    dataConfig: dataConfigTir,
    options: configTir,
    plugins: ChartDataLabels,
    element: Bar,
  },
  {
    dataConfig: dataConfigInsuline,
    options: configInsuline,
    plugins: ChartDataLabels,
    element: Bar,
  },
  {
    dataConfig: dataConfigImc,
    options: configImc,
    plugins: ChartDataLabels,
    element: Bar,
  },
];

export default graphMetrics;
